import React, { useState } from 'react';

const MerchandisingPage: React.FC = () => {
  const [selectedCategory, setSelectedCategory] = useState('todos');

  const productos = [
    // Array vacío - listo para que añadas tus productos
  ];

  const categorias = [
    { id: 'todos', nombre: 'TODOS', icono: 'ri-grid-line' },
    { id: 'ropa', nombre: 'ROPA', icono: 'ri-shirt-line' },
    { id: 'accesorios', nombre: 'ACCESORIOS', icono: 'ri-shopping-bag-line' },
    { id: 'miniaturas', nombre: 'SIMULACIONES Y MINIATURAS', icono: 'ri-fire-line' }
  ];

  const productosFiltrados = selectedCategory === 'todos' 
    ? productos 
    : productos.filter(p => p.categoria === selectedCategory);

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 via-slate-800 to-gray-900">
      {/* Navigation */}
      <nav className="bg-black/80 backdrop-blur-md border-b-2 border-gradient-to-r from-yellow-400 via-orange-500 to-yellow-400">
        <div className="max-w-7xl mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            {/* Logo */}
            <div className="flex items-center space-x-3 ml-0">
              <div className="bg-black/20 backdrop-blur-sm rounded-xl p-1 border border-yellow-400/30">
                <img 
                  src="https://static.readdy.ai/image/f83f5cd629da4d80734129e80e4e4145/4a7f8b54088d811b1f1eaf12115718e6.jpeg" 
                  alt="ESPECTÁCULOS BRONCHÚ Logo" 
                  className="h-14 w-14 rounded-lg shadow-lg object-cover"
                />
              </div>
              <div>
                <h1 className="text-xl font-black text-white font-sans tracking-widest drop-shadow-2xl" style={{fontFamily: 'Inter, system-ui, sans-serif', letterSpacing: '0.2em', textShadow: '2px 2px 4px rgba(0,0,0,0.8)'}}>
                  ESPECTÁCULOS BRONCHÚ
                </h1>
                <p className="text-xs text-yellow-400 font-light tracking-widest" style={{letterSpacing: '0.25em'}}>
                  L'ART DEL FOC I EL SO
                </p>
              </div>
            </div>

            {/* Navigation Menu */}
            <div className="hidden md:flex items-center space-x-8">
              <a href="/" className="text-white hover:text-yellow-400 transition-colors duration-300 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
                INICIO
              </a>
              <a href="/pirotecnia" className="text-white hover:text-yellow-400 transition-colors duration-300 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
                FUEGOS ARTIFICIALES
              </a>
              <a href="/eventos" className="text-white hover:text-yellow-400 transition-colors duration-300 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
                EVENTOS
              </a>
              <a href="/videos" className="text-white hover:text-yellow-400 transition-colors duration-300 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
                VIDEOS
              </a>
              <a href="/calendario" className="text-white hover:text-yellow-400 transition-colors duration-300 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
                CALENDARIO
              </a>
              <a href="/merchandising" className="text-yellow-400 border-b-2 border-yellow-400 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
                MERCHANDISING
              </a>
              <a href="/nosotros" className="text-white hover:text-yellow-400 transition-colors duration-300 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
                NOSOTROS
              </a>
              <a href="/contacto" className="text-white hover:text-yellow-400 transition-colors duration-300 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
                CONTACTO
              </a>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative py-16 sm:py-20">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://readdy.ai/api/search-image?query=professional%20product%20photography%20studio%20setup%20displaying%20branded%20merchandise%20collection%20for%20entertainment%20company%20including%20black%20cotton%20tshirts%20with%20golden%20embroidered%20logos%20hanging%20on%20wooden%20hangers%2C%20premium%20quality%20hoodies%20neatly%20folded%20on%20rustic%20wooden%20shelves%2C%20embroidered%20baseball%20caps%20arranged%20in%20rows%2C%20collectible%20miniature%20pyrotechnic%20device%20replicas%20crafted%20from%20brass%20and%20copper%20materials%2C%20scale%20models%20of%20professional%20stage%20equipment%20and%20lighting%20rigs%2C%20all%20items%20arranged%20on%20industrial%20metal%20display%20racks%20against%20charcoal%20gray%20textured%20wall%20with%20dramatic%20side%20lighting%20creating%20deep%20shadows%20and%20golden%20highlights%2C%20cinematic%20commercial%20photography%20style%20with%20shallow%20depth%20of%20field%2C%20absolutely%20zero%20makeup%20items%20zero%20cosmetic%20products%20zero%20beauty%20supplies%20in%20frame&width=1920&height=600&seq=bronchu-merch-studio-display-2025-v8&orientation=landscape')`
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-b from-gray-900/70 to-gray-800/50"></div>
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 text-center">
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-4 sm:mb-6 tracking-wider drop-shadow-2xl px-2">
            MERCHANDISING
            <span className="block bg-gradient-to-r from-orange-400 via-yellow-400 to-red-500 bg-clip-text text-transparent">
              OFICIAL
            </span>
          </h1>
          <p className="text-base sm:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed px-4">
            Productos exclusivos de ESPECTÁCULOS BRONCHÚ
          </p>
        </div>
      </section>

      {/* Filtros de Categoría */}
      <section className="py-6 sm:py-8 bg-slate-800/50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="flex flex-wrap justify-center gap-3 sm:gap-4">
            {categorias.map((cat) => (
              <button
                key={cat.id}
                onClick={() => setSelectedCategory(cat.id)}
                className={`px-4 sm:px-6 py-2 sm:py-3 rounded-lg font-bold text-xs sm:text-sm tracking-wider transition-all duration-300 flex items-center space-x-2 cursor-pointer whitespace-nowrap ${
                  selectedCategory === cat.id
                    ? 'bg-yellow-400 text-black scale-105'
                    : 'bg-black/40 text-white hover:bg-black/60 border border-yellow-400/30'
                }`}
              >
                <i className={`${cat.icono} text-base sm:text-lg`}></i>
                <span className="hidden sm:inline">{cat.nombre}</span>
                <span className="sm:hidden">{cat.nombre.split(' ')[0]}</span>
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Grid de Productos */}
      <section className="py-16 bg-gradient-to-b from-slate-800 to-slate-700">
        <div className="max-w-7xl mx-auto px-6">
          {productosFiltrados.length === 0 ? (
            <div className="text-center py-20">
              <i className="ri-shopping-bag-line text-6xl text-yellow-400/50 mb-4"></i>
              <h3 className="text-2xl font-bold text-white mb-2">No hay productos disponibles</h3>
              <p className="text-gray-400">Próximamente añadiremos productos a esta sección</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8" data-product-shop>
              {productosFiltrados.map((producto) => (
                <div 
                  key={producto.id}
                  className="bg-black/40 backdrop-blur-sm rounded-2xl overflow-hidden border border-yellow-400/20 hover:border-yellow-400/50 transition-all duration-300 hover:scale-105 group"
                >
                  {/* Imagen del Producto */}
                  <div className="relative w-full h-80 overflow-hidden">
                    <img 
                      src={producto.imagen}
                      alt={producto.nombre}
                      className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute top-4 right-4 bg-yellow-400 text-black px-3 py-1 rounded-full font-bold text-sm">
                      {producto.precio}€
                    </div>
                  </div>

                  {/* Información del Producto */}
                  <div className="p-6">
                    <h3 className="text-white font-bold text-lg mb-2 tracking-wider">
                      {producto.nombre}
                    </h3>
                    <p className="text-gray-400 text-sm leading-relaxed">
                      {producto.descripcion}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-r from-yellow-400/10 to-orange-500/10">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold text-white mb-6 tracking-wider">
            ¿NECESITAS PRODUCTOS PERSONALIZADOS?
          </h2>
          <p className="text-gray-300 text-lg mb-8 leading-relaxed">
            Ofrecemos servicios de personalización para eventos corporativos y celebraciones especiales
          </p>
          <a 
            href="/contacto"
            className="inline-block bg-yellow-400 text-black px-8 py-4 rounded-lg font-bold text-lg tracking-wider hover:scale-105 transition-transform duration-300 cursor-pointer whitespace-nowrap"
          >
            SOLICITAR INFORMACIÓN
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gradient-to-t from-slate-800 to-gray-700 py-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-12">
            {/* Logo y Descripción */}
            <div className="lg:col-span-2">
              <h3 className="text-white text-2xl font-serif font-bold mb-4">
                ESPECTÁCULOS BRONCHÚ
                <span className="text-yellow-400 text-lg">.</span>
              </h3>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Especialistas en pirotécnica profesional y entretenimiento con más de 25 años de experiencia creando momentos únicos e inolvidables.
              </p>
              <div className="flex space-x-4">
                <a href="#" className="border-2 border-yellow-400 text-yellow-400 w-10 h-10 rounded-lg flex items-center justify-center hover:bg-yellow-400 hover:text-black transition-all duration-300 cursor-pointer">
                  <i className="ri-instagram-line"></i>
                </a>
                <a href="#" className="border-2 border-yellow-400 text-yellow-400 w-10 h-10 rounded-lg flex items-center justify-center hover:bg-yellow-400 hover:text-black transition-all duration-300 cursor-pointer">
                  <i className="ri-youtube-line"></i>
                </a>
              </div>
            </div>

            {/* Enlaces Rápidos */}
            <div>
              <h4 className="text-white font-bold text-lg mb-6 tracking-wider">SERVICIOS</h4>
              <ul className="space-y-3">
                <li><a href="/pirotecnia" className="text-gray-300 hover:text-yellow-400 transition-colors duration-300 cursor-pointer">FUEGOS ARTIFICIALES</a></li>
                <li><a href="/eventos" className="text-gray-300 hover:text-yellow-400 transition-colors duration-300 cursor-pointer">EVENTOS</a></li>
                <li><a href="/videos" className="text-gray-300 hover:text-yellow-400 transition-colors duration-300 cursor-pointer">GALERÍA</a></li>
                <li><a href="/merchandising" className="text-gray-300 hover:text-yellow-400 transition-colors duration-300 cursor-pointer">MERCHANDISING</a></li>
              </ul>
            </div>

            {/* Contacto */}
            <div>
              <h4 className="text-white font-bold text-lg mb-6 tracking-wider">CONTACTO</h4>
              <ul className="space-y-3">
                <li className="text-gray-300">693 812 675</li>
                <li className="text-gray-300">info@espectaculosbronchu.es</li>
                <li className="text-gray-300">VALENCIA, ESPAÑA</li>
                <li><a href="/contacto" className="text-yellow-400 hover:underline cursor-pointer">SOLICITAR PRESUPUESTO</a></li>
              </ul>
            </div>
          </div>

          {/* Bottom Footer */}
          <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col lg:flex-row items-center justify-between">
            <p className="text-gray-400 text-sm mb-4 lg:mb-0">
              © 2025 ESPECTÁCULOS BRONCHÚ. TODOS LOS DERECHOS RESERVADOS.
            </p>
            
            <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 text-sm hover:text-yellow-400 transition-colors duration-300 cursor-pointer">
              Powered by Readdy
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default MerchandisingPage;
